import contact       from '../pages/contact/ContactPage.vue'


export default [
    {
        path: '/contact',
        name: 'contact',
        component: contact,
    }
]
